import { Flex, ModalV2 } from '@electricjs/arc';
import { CenteredSpinner } from '@common';

import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { useGetOrganizationPackagesQuery } from '@/redux/slices/packageApiSlice';
import { useCustomerRedirectSegment } from '@/hooks/useCustomerRedirectSegment';
import { useCustomerRedirectParams } from '@/hooks/useCustomerRedirectParams';
import { CUSTOMER_REDIRECT_URLS } from '@/constants/customerRedirects';
import SupportRedirectModal from '@/components/Licenses/SupportRedirectModal';

import AddLicensesForm from './AddLicensesForm';

type AddLicensesModalProps = {
  onClose: () => void;
  onSuccess?: () => void;
};

// Gatekeeper: decides between the self-serve form and the support-redirect
// modal before the form's heavier queries (invoices, pending subscription
// change) ever run, based only on the org packages fetch every caller
// already shares via the RTK Query cache.
const AddLicensesModal = ({ onClose, onSuccess }: AddLicensesModalProps) => {
  const organizationId = useGetOrganizationId();
  const { data: orgPackages, isLoading } =
    useGetOrganizationPackagesQuery(organizationId);
  const customerRedirectSegment = useCustomerRedirectSegment(orgPackages);
  const customerRedirectParams = useCustomerRedirectParams(
    organizationId,
    orgPackages
  );

  if (isLoading) {
    return (
      <ModalV2
        ariaLabelledby="add-licenses-modal-loading"
        hide={onClose}
        visible>
        <Flex height="20rem" justifyContent="center" alignItems="center">
          <CenteredSpinner mt="0" />
        </Flex>
      </ModalV2>
    );
  }

  if (customerRedirectSegment) {
    return (
      <SupportRedirectModal
        onClose={onClose}
        redirectUrl={CUSTOMER_REDIRECT_URLS[
          customerRedirectSegment
        ].licenseExpansionUrl(customerRedirectParams)}
        isAtLimit={customerRedirectParams.isAtLicenseLimit}
      />
    );
  }

  return <AddLicensesForm onClose={onClose} onSuccess={onSuccess} />;
};

export default AddLicensesModal;
